export enum AssetManagement {
    Internal = "Internal",
    External = "External"
}